export default "__VITE_ASSET__BqCp1YQi__";